import React from 'react'
import { CHART_TYPES, CHART_TYPE_LABELS } from '../../mock'

export const ChartTypes = ({ selectedFilters, setSelectedFilters }) => {
  const onPress = (item) => {
    setSelectedFilters({ ...selectedFilters, chartType: item })
  }

  return (
    <div
      style={{
        fontSize: '16px',
        fontFamily: ' Roboto, sans-serif',
        width: '100%',
      }}
      className="ClearTheCharts__label"
    >
      <p>Chart types</p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          width: '100%',
          rowGap: '10px',
        }}
      >
        {Object.entries(CHART_TYPES).map(([value, label], idx) => {
          const isSelected = value === selectedFilters.chartType
          return (
            <div
              key={value}
              onClick={() => onPress(value)}
              className="PreflopCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
              }}
            >
              <div className="PreflopCharts__button-label">
                {CHART_TYPE_LABELS[value]}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
